
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctors",
      function () {
        return require("private-next-pages/doctors/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doctors"])
      });
    }
  